import React from 'react';
import logo from "../../assets/images/live/live-mt.png"
import Banner from "./Banner";

const Head = () => {
    return (
        <div className="live-header">
            <div>
                <img src={logo} alt="logo" className="live-logo"/>
            </div>
            <div>
                <div className="t-h-1">CHUYÊN TRANG KẾT QUẢ XỔ SỐ KIẾN THIẾT</div>
                <div className="t-h-2">MINH NGỌC</div>
                <div className="t-h-3">www.minhngocc.net</div>
            </div>
            <div className="live-banner">
                <Banner/>
            </div>
        </div>
    );
};

export default Head;